import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import localeES from '@angular/common/locales/es-CO';
import { registerLocaleData } from '@angular/common';
import { StoreModule } from '@ngrx/store';

import { AppComponent } from './app.component';
import { LayoutModule } from './theme/layout/layout.module';
import { documentsReducer } from './shared/state/reducers/documents.reducer';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RequestInterceptorService } from './interceptors/request-interceptor.service';
import { AuthService } from './services/auth.service';
import { LocalStorageService } from './services/local-storage.service';
import { globalReducer } from './shared/state/reducers/global.reducer';
import { GraphQLModule } from './graphql.module';

registerLocaleData(localeES);

@NgModule({
	declarations: [
		AppComponent,
	],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		RouterModule.forRoot([]),
		LayoutModule,
		HttpClientModule, 
		StoreModule.forRoot({ documents: documentsReducer, global: globalReducer }),
		GraphQLModule
	],
	providers: [
		{
			provide: LOCALE_ID,
			useValue: 'es-CO'
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: RequestInterceptorService, // Clase interceptor
			multi: true, // Pendiente de todas las peticiones.
		},
		AuthService,
		LocalStorageService
	],
	bootstrap: [AppComponent]
})
export class AppModule { }
